<template>
    <div class="area-page-wrapper">
        <div class="area-page-container">
            <div class="detail-card">
                <div class="header-container">
                    <button class="back-button" @click="goBack">
                        <i class="back-icon">←</i> Torna Indietro
                    </button>
                    <h2 class="page-title-istanza">{{ userData.descrizione }}</h2>
                </div>
                <hr class="divider" />
                <div class="details-grid">
                    <div class="detail-item">
                        <span class="detail-label">Anno:</span>
                        <span class="detail-value">{{ userData.anno }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Da:</span>
                        <span class="detail-value">{{ formatDate(userData.from) }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Stato:</span>
                        <span class="status-indicator" :class="{ 'active': userData.status }">
                            {{ userData.status ? 'Aperto' : 'Chiuso' }}
                        </span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">A:</span>
                        <span class="detail-value">{{ formatDate(userData.to) }}</span>
                    </div>
                    <div class="action-container">
                        <span class="detail-label action-label">Seleziona Azione:</span>
                        <div class="action-buttons">
                            <button @click="handleAction('inserisci-allegato')">Inserisci Allegato</button>
                            <button @click="handleAction('inserisci-template')">Inserisci Template</button>
                            <button @click="handleAction('visualizza-template')">Visualizza Template</button>
                            <button @click="handleAction('anteprima-dati')">Anteprima Dati</button>
                            <button v-if="userData.status" @click="handleAction('chiudi-istanza')"
                                style="background-color: #bb3737;">Chiudi
                                Istanza</button>
                            <button v-else @click="handleAction('apri-istanza')" style="background-color: #26ad5f;">Apri
                                Istanza</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showFileUploadModal" class="modal-overlay">
            <div class="modal-container">
                <div class="modal-header">
                    <h3>{{ uploadType === 'allegato' ? 'Inserisci Allegato' : 'Inserisci Template' }}</h3>
                    <button class="close-button" @click="closeModal">×</button>
                </div>
                <div class="modal-content">
                    <div class="upload-zone" :class="{ 'drag-over': isDragging }" @drop.prevent="handleDrop"
                        @dragover.prevent="isDragging = true" @dragleave.prevent="isDragging = false"
                        @click="triggerFileInput">
                        <input type="file" ref="fileInput" @change="handleFileSelect" class="hidden-input">
                        <div class="upload-message">
                            <i class="upload-icon">📁</i>
                            <p>Trascina qui il tuo file o clicca per selezionarlo</p>
                            <span class="file-info" v-if="selectedFile">
                                File selezionato: {{ selectedFile.name }}
                            </span>
                        </div>
                    </div>
                    <div class="button-container">
                        <button class="upload-button" @click="uploadFile" :disabled="!selectedFile">
                            Carica File
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal di risposta -->
        <div v-if="showResponseModal" class="modal-overlay">
            <div class="modal-container">
                <div class="modal-header">
                    <h3>Risultato Upload</h3>
                    <button class="close-button" @click="closeResponseModal">×</button>
                </div>
                <div class="modal-content">
                    <div :class="['response-message', responseMessage === 'OK' ? 'success' : 'error']">
                        {{ responseMessage }}
                    </div>
                    <div class="button-container">
                        <button class="upload-button" @click="closeResponseModal">Chiudi</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabella dei dati modificata con filtri dei periodi -->
        <!-- Loader durante il caricamento dei dati -->
        <div v-if="caricamentoTabella" class="loader-container">
            <div class="loader"></div>
            <p>Caricamento dati in corso...</p>
        </div>

        <!-- Tabella dei dati -->
        <div v-if="showTabella && !caricamentoTabella" class="tabella-container">
            <div class="tabella-controls">
                <div class="periodo-selector">
                    <span class="selector-label">Scegli periodo:</span>
                    <button @click="cambiaFiltro('prsem')"
                        :class="['periodo-button', periodoAttivo === 'prsem' ? 'active' : '']">
                        PRRIMO SEMESTRE
                    </button>
                    <button @click="cambiaFiltro('sesem')"
                        :class="['periodo-button', periodoAttivo === 'sesem' ? 'active' : '']">
                        SECONDO SEMESTRE
                    </button>
                </div>
                <div>
                    <button @click="scaricaExcel" class="scarica-excel-button">
                        Scarica Excel
                    </button>
                    <button @click="chiudiTabella" class="chiudi-tabella-button">
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </div>
            <table class="file-table">
                <thead>
                    <tr>
                        <th>Periodo</th>
                        <th>Intervallo</th>
                        <th>Energia</th>
                        <th>Materia</th>
                        <th>Rete</th>
                        <th>Oneri</th>
                        <th>Accisa</th>
                        <th>IVA</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in datiTabellaMostrati" :key="index">
                        <td>{{ item.periodo }}</td>
                        <td>{{ item.intervallo }}</td>
                        <td>{{ item.energia }}</td>
                        <td>{{ item.materia }}</td>
                        <td>{{ item.rete }}</td>
                        <td>{{ item.oneri }}</td>
                        <td>{{ item.accisa }}</td>
                        <td>{{ item.iva }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import axios from "axios";
import { useRoute, useRouter } from 'vue-router';
import * as XLSX from 'xlsx';

export default {
    setup() {
        const route = useRoute();
        const router = useRouter();
        const userData = ref({});
        const loading = ref(true);
        const showFileUploadModal = ref(false);
        const showResponseModal = ref(false);
        const isDragging = ref(false);
        const selectedFile = ref(null);
        const responseStatus = ref('');
        const fileInput = ref(null);
        const uploadType = ref('');
        const responseMessage = ref('');
        const datiTabella = ref([]);
        const showTabella = ref(false);
        const periodoAttivo = ref('prsem'); // Cambiato a 'prsem' come valore predefinito
        const datiTabellaMostrati = ref([]);
        const caricamentoTabella = ref(false);

        const goBack = () => {
            router.back();
        };

        const fetchRaccoltaDatiIstanza = async () => {
            loading.value = true;
            try {
                const response = await axios.post("http://127.0.0.1:8001/api/getRaccoltaDatiIstanza", {
                    crdi: route.query.id
                });
                userData.value = response.data;
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                loading.value = false;
            }
        };

        const chiudiIstanza = async () => {
            try {
                await axios.post("http://127.0.0.1:8001/api/chiudiRaccoltaDatiIstanza", {
                    crdi: route.query.id
                });
                userData.value.status = 0;
            } catch (error) {
                console.error("Error closing instance:", error);
            }
        };

        const apriIstanza = async () => {
            try {
                await axios.post("http://127.0.0.1:8001/api/apriRaccoltaDatiIstanza", {
                    crdi: route.query.id
                });
                userData.value.status = 1;
            } catch (error) {
                console.error("Error opening instance:", error);
            }
        };

        const formatDate = (dateString) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        };

        const closeModal = () => {
            showFileUploadModal.value = false;
            selectedFile.value = null;
            isDragging.value = false;
        };

        const triggerFileInput = () => {
            fileInput.value.click();
        };

        const handleFileSelect = (event) => {
            const file = event.target.files[0];
            if (file) {
                selectedFile.value = file;
            }
        };

        const handleDrop = (event) => {
            isDragging.value = false;
            const file = event.dataTransfer.files[0];
            if (file) {
                selectedFile.value = file;
            }
        };

        const closeResponseModal = () => {
            showResponseModal.value = false;
            responseMessage.value = '';
            responseStatus.value = '';
            if (responseStatus.value === 'OK') {
                closeModal();
            }
        };

        const uploadFile = async () => {
            if (!selectedFile.value) return;

            const formData = new FormData();
            formData.append('file', selectedFile.value);
            formData.append('crdi', route.query.id);

            try {
                const endpoint = uploadType.value === 'allegato'
                    ? 'http://127.0.0.1:8001/api/uploadAllegato'
                    : 'http://127.0.0.1:8001/api/uploadTemplate';

                const response = await axios.post(endpoint, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                console.log("Risposta backend:", response.data);
                responseMessage.value = response.data.response;
                showResponseModal.value = true;

                if (response.data.response === 'OK') {
                    setTimeout(() => {
                        closeModal();
                        fetchRaccoltaDatiIstanza();
                    }, 1500);
                }

            } catch (error) {
                console.error("Errore Axios:", error.response?.data || error.message);
            }
        };

        const scaricaExcel = () => {
            if (!datiTabellaMostrati.value || datiTabellaMostrati.value.length === 0) {
                console.error("Nessun dato da scaricare");
                return;
            }

            const wb = XLSX.utils.book_new();

            const titoloPeriodo = periodoAttivo.value === 'prsem'
                ? "Dati Primo Semestre"
                : "Dati Secondo Semestre";

            const datiExport = datiTabellaMostrati.value.map(item => ({
                Periodo: item.periodo,
                Intervallo: item.intervallo,
                Energia: item.energia,
                Materia: item.materia,
                Rete: item.rete,
                Oneri: item.oneri,
                Accisa: item.accisa,
                IVA: item.iva
            }));

            const ws = XLSX.utils.json_to_sheet(datiExport);

            XLSX.utils.book_append_sheet(wb, ws, titoloPeriodo);

            const now = new Date();
            const nomefile = `dati_${periodoAttivo.value}_${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.xlsx`;

            // Scarica il file Excel
            XLSX.writeFile(wb, nomefile);

            console.log("File Excel scaricato:", nomefile);
        };

        const chiudiTabella = () => {
            showTabella.value = false;
        };

        // Nuova funzione per costruire l'URL in base al periodo e all'anno
        const costruisciUrlDati = (periodo) => {
            const anno = userData.value?.anno || new Date().getFullYear();
            return `https://processi.askmanagement.it/api/arera/getPrezziMediClientiEleBonusNoBonus/bonus/${periodo}/${anno}/j`;
        };

        const fetchDatiAnteprima = async () => {
            caricamentoTabella.value = true;
            showTabella.value = true;

            try {
                const url = costruisciUrlDati(periodoAttivo.value);
                console.log("Fetching data from URL:", url);
                
                const response = await axios.get(url);
                const datiTrasformati = [];

                // Trasforma i dati JSON in formato tabellare
                for (const periodo in response.data) {
                    const intervalli = response.data[periodo];
                    for (const intervallo in intervalli) {
                        const valori = intervalli[intervallo];
                        datiTrasformati.push({
                            periodo: periodo,
                            intervallo: intervallo,
                            energia: valori.energia || 0,
                            materia: valori.materia || 0,
                            rete: valori.rete || 0,
                            oneri: valori.oneri || 0,
                            accisa: valori.accisa || 0,
                            iva: valori.iva || 0,
                        });
                    }
                }

                console.log("Dati caricati:", datiTrasformati);
                datiTabella.value = datiTrasformati;
                datiTabellaMostrati.value = datiTrasformati;

                setTimeout(() => {
                    caricamentoTabella.value = false;
                }, 500);

            } catch (error) {
                console.error("Errore nel recupero dei dati:", error);
                caricamentoTabella.value = false;
            }
        };

        const cambiaFiltro = async (periodo) => {
            periodoAttivo.value = periodo;
            console.log(`Cambio filtro a: ${periodo}`);
            caricamentoTabella.value = true;
            
            try {
                const url = costruisciUrlDati(periodo);
                console.log("Fetching data from URL:", url);
                
                const response = await axios.get(url);
                const datiTrasformati = [];

                // Trasforma i dati JSON in formato tabellare
                for (const periodo in response.data) {
                    const intervalli = response.data[periodo];
                    for (const intervallo in intervalli) {
                        const valori = intervalli[intervallo];
                        datiTrasformati.push({
                            periodo: periodo,
                            intervallo: intervallo,
                            energia: valori.energia || 0,
                            materia: valori.materia || 0,
                            rete: valori.rete || 0,
                            oneri: valori.oneri || 0,
                            accisa: valori.accisa || 0,
                            iva: valori.iva || 0,
                        });
                    }
                }

                datiTabella.value = datiTrasformati;
                datiTabellaMostrati.value = datiTrasformati;
                
            } catch (error) {
                console.error("Errore nel recupero dei dati:", error);
            } finally {
                caricamentoTabella.value = false;
            }
        };

        // Gestione delle azioni
        const handleAction = async (action) => {
            console.log('Action selected:', action);
            switch (action) {
                case 'chiudi-istanza':
                    await chiudiIstanza();
                    break;
                case 'apri-istanza':
                    await apriIstanza();
                    break;
                case 'inserisci-allegato':
                    uploadType.value = 'allegato';
                    showFileUploadModal.value = true;
                    break;
                case 'inserisci-template':
                    uploadType.value = 'template';
                    showFileUploadModal.value = true;
                    break;
                case 'anteprima-dati':
                    await fetchDatiAnteprima();
                    break;
                default:
                    console.log('Action not implemented:', action);
            }
        };

        onMounted(() => {
            fetchRaccoltaDatiIstanza();
        });

        return {
            goBack,
            userData,
            loading,
            showFileUploadModal,
            showResponseModal,
            responseStatus,
            isDragging,
            selectedFile,
            fileInput,
            uploadType,
            responseMessage,
            datiTabella,
            showTabella,
            caricamentoTabella,
            chiudiTabella,
            scaricaExcel,
            handleAction,
            formatDate,
            closeModal,
            closeResponseModal,
            triggerFileInput,
            handleFileSelect,
            handleDrop,
            uploadFile,
            periodoAttivo,
            datiTabellaMostrati,
            cambiaFiltro,
        };
    }
};
</script>

<style scoped>
html,
body {
    overflow: hidden;
    height: 100%;
    margin: 0;
    padding: 0;
}

.header-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 2rem;
    width: 100%;
}

.back-button {
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    padding: 8px 16px;
    background-color: #448c94;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.back-button:hover {
    background-color: #357b83;
    transform: translateX(-3px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
}


.back-icon {
    margin-right: 8px;
}

.divider {
    border: 0;
    height: 1px;
    background: #ccc;
    width: 100%;
    margin-bottom: 10px !important;
}

.area-page-wrapper {
    padding: 20px;
}

.area-page-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
}

.page-title-istanza {
    text-align: center;
    padding-left: 150px;
    padding-right: 150px;
    margin: 0;
    font-size: 1.5rem;
    text-overflow: ellipsis;
    color: var(--text-primary) !important;
}

.detail-card {
    background: white;
    padding: 2rem;
    border-radius: 16px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
    width: 85%;
    max-width: 1200px;
    margin-top: 20px;
}

.details-grid {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 5rem;
}

.detail-item {
    flex: 1 1 45%;
    display: flex;
    justify-content: space-between;
    font-size: 1rem;
    padding: 0.5rem;
}

.detail-label {
    font-weight: bold;
    color: #34495e;
    margin-right: 0.4rem;
}

.detail-value {
    color: #2c3e50;
    font-size: 1rem;
}

.status-indicator {
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    text-align: center;
    color: white;
    font-size: 0.85rem;
    display: inline-block;
    min-width: 80px;
}

.status-indicator.active {
    background-color: #27ae60;
}

.status-indicator:not(.active) {
    background-color: #e74c3c;
}

.action-container {
    display: flex;
    align-items: baseline;
    justify-content: space-evenly;
    margin-top: 3rem;
    align-content: space-around;
}

.action-label {
    margin-right: 1rem;
}

.action-buttons {
    display: flex;
    gap: 0.5rem;
}

.action-buttons button {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 7px;
    background-color: #448c94;
    color: white;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
}

.action-buttons button:hover {
    background-color: #2980b9;
    transform: scale(1.05);
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(4px);
    transition: all 0.3s ease;
}

.modal-container {
    background-color: white;
    border-radius: 16px;
    width: 90%;
    max-width: 500px;
    padding: 20px;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    transform: translateY(0);
    transition: transform 0.3s ease;
    animation: modal-appear 0.4s ease;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.modal-header h3 {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.modal-content {
    padding: 24px;
}

@keyframes modal-appear {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.close-button {
    background: none;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    transition: all 0.2s ease;
}

.close-button:hover {
    color: #000;
}

.upload-zone {
    border: 2px dashed #ccc;
    border-radius: 4px;
    padding: 40px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.upload-zone.drag-over {
    background-color: #f7f7f7;
    border-color: #448c94;
}

.hidden-input {
    display: none;
}

.upload-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.upload-icon {
    font-size: 48px;
}

.file-info {
    margin-top: 10px;
    color: #448c94;
    font-weight: bold;
}

.button-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.upload-button {
    padding: 12px 28px;
    background-color: #448c94;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(68, 140, 148, 0.2);
}

.upload-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    box-shadow: none;
}

.upload-button:hover:not(:disabled) {
    background-color: #357b83;
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(68, 140, 148, 0.3);
}

.upload-button:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(68, 140, 148, 0.2);
}

.response-message {
    padding: 24px;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 24px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    transition: all 0.3s ease;
    position: relative;
}

.response-message::before {
    content: "✅";
    font-size: 48px;
    margin-bottom: 12px;
}

.response-message.success {
    background-color: #e9f7ef;
    color: #27ae60;
    border: none;
}

.response-message.success::before {
    content: "✅";
    color: #27ae60;
}

.response-message.error {
    background-color: #fdedec;
    color: #e74c3c;
    border: none;
}

.response-message.error::before {
    content: "❌";
    color: #e74c3c;
}

.tabella-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    width: 90%;
    margin: 20px auto;
    padding: 15px;
}

.tabella-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.periodo-selector {
    display: flex;
    align-items: center;
    gap: 10px;
}

.selector-label {
    font-weight: bold;
    color: #34495e;
}

.periodo-button {
    padding: 8px 16px;
    border: 1px solid #1e5a38;
    border-radius: 4px;
    background-color: white;
    color: #448c94;
    cursor: pointer;
}

.periodo-button.active {
    background-color: #1e5a38;
    color: white;
}

.chiudi-tabella-button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background-color: transparent;
    color: #e53935;
    cursor: pointer;
    font-size: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease, color 0.2s ease;
    margin-left: 5px;
    vertical-align: middle;
    height: 35px;
}

.chiudi-tabella-button:hover {
    color: #c62828;
}

.chiudi-tabella-button i {
    font-weight: bold;
}

.scarica-excel-button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background-color: #28a745;
    color: white;
    cursor: pointer;
    margin-right: 10px;
}

.scarica-excel-button:hover {
    background-color: #218838;
}

.file-table {
    width: 100%;
    border-collapse: collapse;
}

.file-table th {
    background-color: #448c94;
    color: white;
    padding: 10px;
    text-align: left;
}

.file-table td {
    padding: 8px;
    border-bottom: 1px solid #ddd;
}

.loader-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;
    margin: 20px auto;
    padding: 30px;
}

.loader {
    border: 5px solid #f3f3f3;
    border-top: 5px solid #1e5a38;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@media (max-width: 768px) {
    .header-container {
        flex-direction: column;
        gap: 0.75rem;
    }

    .back-button-container {
        margin-right: 0;
        align-self: flex-start;
    }

    .title-container {
        width: 100%;
    }

    .page-title-istanza {
        font-size: 1.3rem;
        text-align: center;
    }
}

/* Per schermi molto piccoli */
@media (max-width: 480px) {
    .back-button {
        padding: 6px 12px;
        font-size: 0.8rem;
    }

    .page-title-istanza {
        font-size: 1.1rem;
    }
}
</style>